module.exports = __webpack_public_path__ + "static/2-2c2a8e15c7efd9b2d98d8c6da1379be4.png";